<script setup lang="ts">
const el = ref()
const v = useElementVisibility(el)
</script>

<template>
  <div ref="el" relative h-496px w-full>
    <svg
      :class="v && 'animated-fade-in-right'"
      absolute animated
      class="right-[clamp(-10000px,calc((100vw-1920px)/2.25+0px),0px)]"
      lg="right-[clamp(-10000px,calc((100vw-1920px)/2+0px),0px)]" xmlns="http://www.w3.org/2000/svg" width="1131" height="496" viewBox="0 0 1131 496" fill="none"
    >
      <path d="M1131 496H0L342.5 0H1131V496Z" fill="#CE0000" />
    </svg>

    <div absolute inset-0 container row items-center justify-center>
      <div z-2 text-center>
        <p class="text-35px font-bold lh-100% lg:text-80px" :class="v && 'animated-fade-in-right'" animated animated-delay-200>
          CONTACT US
        </p>
        <p :class="v && 'animated-fade-in-right'" mt-20px text-24px font-bold animated animated-delay-300 lg:text-24px>
          sponsor@missweb3.org
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
</style>
